import { AppShell, Box } from "@mantine/core"
import { useDisclosure, useMediaQuery } from "@mantine/hooks"
import { useUserOption } from "@/hooks"
import { theme } from "@/styles"
import { AppHeader } from "./AppHeader"
import { BaseLayout } from "./BaseLayout"
import { SideMenu } from "./navigation"

export function ShellLayout({ children }) {
  const [navbar, { toggle }] = useDisclosure()
  const xs = useMediaQuery(`(max-width: ${theme.breakpoints?.xs})`)
  const [collapsed, setCollapsed] = useUserOption("sideMenuCollapsed", false)

  return (
    <BaseLayout>
      <AppShell
        header={{ height: xs ? 50 : 0.01 }}
        navbar={{
          width: collapsed ? 70 : 240,
          breakpoint: "sm",
          collapsed: { mobile: !navbar },
        }}
      >
        {xs && <AppHeader toggleNavbar={toggle} navbarOpened={navbar} />}
        <SideMenu
          xs={xs}
          hidden={xs || !navbar}
          collapsed={!!collapsed}
          onToggleCollapse={() => setCollapsed(!collapsed)}
        />
        <AppShell.Main bg="var(--mantine-color-panel)" pb="xl">
          <Box pos="relative">{children}</Box>
        </AppShell.Main>
      </AppShell>
    </BaseLayout>
  )
}
